var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "gBody",
      staticClass: "g-body",
      staticStyle: { "overflow-scrolling": "touch" },
      attrs: { id: "gBody" }
    },
    [
      _c("SiteHead", { staticClass: "SiteHead" }),
      _vm._v(" "),
      _c(
        "SiteBody",
        { ref: "pageBody", staticClass: "p-body" },
        [
          _c("BannerModuleVue"),
          _vm._v(" "),
          _c("IntroModule", { staticClass: "IntroModule" }),
          _vm._v(" "),
          _c("MarketModule", {
            staticClass: "MarketModule",
            attrs: { marketList: _vm.marketList }
          }),
          _vm._v(" "),
          _c("DownloadModule", { staticClass: "DownloadModule" }),
          _vm._v(" "),
          _c("PresenceModule", { staticClass: "PresenceModule" }),
          _vm._v(" "),
          _c("StoryModule", { staticClass: "StoryModule" }),
          _vm._v(" "),
          _c("SiteMap", { staticClass: "SiteMap" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex justify-between items-center",
              class: _vm.$style["join-us"]
            },
            [
              _c("div", { class: _vm.$style["state-pos-left"] }, [
                _c("img", {
                  class: _vm.$style["join-us-thumb"],
                  attrs: {
                    src: require("@/assets/images/newImg/join-usV3.png"),
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { class: _vm.$style["state-pos-right"] }, [
                _c("button", { class: _vm.$style["btn--download-app"] }, [
                  _c(
                    "span",
                    {
                      class: _vm.$style["text"],
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            path: "/download",
                            query: { type: "purchase" }
                          })
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300345")))]
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("SiteFoot")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-482e5233", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-482e5233","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/newIndex.vue
// module id = lqVk
// module chunks = 0